import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';

import { Icon, Button } from 'semantic-ui-react';
import Tooltip from 'material-ui/Tooltip';
import { EduQuizDeleteModal } from 'components';

class EduQuizTableMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleteModal: false
    };
  }

  toggleDeleteModal = () => {
    this.setState({ deleteModal: !this.state.deleteModal });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { deleteModal } = this.state;
    const { isAuth, quizInfo, onToggleModal, getQuizInfo } = this.props;
    const { toggleDeleteModal } = this;

    return (
      <div className={'inline-conf-area'} style={{ justifyContent: 'center' }}>
        <Tooltip
          title={defineMessages(formatMessage({ id: 'Quiz_10', defaultMessage: '퀴즈 수정' }))}
          placement="bottom">
          <Icon color="grey" className="icon-edit" name="edit" link onClick={() => { onToggleModal('eduQuizEdit'); getQuizInfo(quizInfo); }} />
        </Tooltip>

        <Tooltip
          title={defineMessages(formatMessage({ id: 'Quiz_11', defaultMessage: '퀴즈 삭제' }))}
          placement="bottom">
          <Icon color="grey" className="icon-remove" name="remove circle" link onClick={toggleDeleteModal} />
        </Tooltip>
        {deleteModal && (<EduQuizDeleteModal isAuth={isAuth} quizInfo={quizInfo} toggleDeleteModal={toggleDeleteModal} />)}
      </div>
    );
  }
}

export default injectIntl(EduQuizTableMenu);



// WEBPACK FOOTER //
// ./src/script/components/edu/EduQuizTableMenu.js